






















































































import { PageMode } from '@/main/utils/pageMode';
import { UPDATE_BASIC_FILTER } from '@/main/store/listEditTypes';
import { listFactory } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { Partner } from '@/modules/kartoteka/partner';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { Ozakazka } from '@/modules/servis/ozakazka';
import { infoButton } from '@/main/utils/tableOperations';
import { apiProvider } from '@/modules/servis/zakazka/api';

import dayJs from 'dayjs';

import { cellNames, CellNamesObject, getColumnsRowMapObject, Row, intToRgb } from '@/main/utils/table';

import { formatDate } from '@/main/utils/dateFormatter';

import _ from 'lodash';

import { objectToCamelCaseShallow } from '@/main/utils/stringHelper';

import { NAME } from './constants';
import { store } from './store/list';
import CreateModal from './components/CreateModal.vue';
import { types } from './store/types';

import JobCardOperationModal from './components/JobCardOperationModal.vue';

export default listFactory(NAME, store).extend({
	components: {
		CreateModal,
		PartnerSelect: Partner.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		OzakazkaSelect: Ozakazka.components.Select,
		JobCardOperationModal,
	},
	data() {
		return {
			vuexMutationWatcherUnsubscribe: null as null|(() => void),
			infoButton,
			visibleJobCardModal: false,
			serviceAdviserDetails:
			{
				isIframeJobListVisible: false,
				iframeJobListUrl: '',
				isIframeUrl: '',
				saName: '',
				saUrl: '',
				technicianUrl: '',
				technicianName: '',
				teamLead: '',
				rONumber: '',
				vINNo: '',
				vehicleRegistrationNumber: '',
				rODate: '',
			},
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				partner: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_ZAKAZNIK_SELECT_MAPPER}`,
				ozakazka: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_OZAKAZKA_SELECT_MAPPER}`,
				pojistovna: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_POJISTOVNA_SELECT_MAPPER}`,
				leazingZakaznik: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_LEAZING_ZAKAZNIK_SELECT_MAPPER}`,
				smluvniPartner: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_SMLUNI_PARTNER_SELECT_MAPPER}`,
				zadavatel: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_ZADAVATEL_SELECT_MAPPER}`,
			};
		},

		tableListeners(): {} {
			return {
				sideBarSelectRow: this.sideBarSelectRow,
				'save-column-setting': this.saveColumnSetting,
				selectedRow: this.selectedRow,
				editClick: this.editZakazka,
				viewClick: this.viewZakazka,
				'sort-change': this.saveSort,
			};
		},
		extraButtons(): any {
			if (this.dmsSys.WarrantyPrp) {
				return {
					...infoButton((e: any, cells: any) => this.getOrderDetails(
						cells[this.table.cellNames!.ZAKAZKA_ID],
					)),
				};
			}
			return {};
		},
		cellNamesCmp(): CellNamesObject {
			return cellNames(this.table);
		},
	},
	created() {
		if (!this.mainCollapse.length) {
			// Ostatni tab is opened by default
			this.mainCollapse = ['5'];
		}
	},
	methods: {
		rowClassName({ row, rowIndex } : { row: Row, rowIndex: number }) {
			if (row) {
				const data = getColumnsRowMapObject(this.table.columns, row.cells);
				if (data.HOTOVO_DAT !== null) {
					const completionDate = dayJs(data.HOTOVO_DAT);
					const currentDate = dayJs(new Date());
					const dateComparision = (completionDate.diff(currentDate, 'minute') < 60 && completionDate.diff(currentDate, 'minute') > 0);
					if (dateComparision) {
						return 'blink_me';
					}
				}
			}
			return '';
		},
		tableCellStyle({ row, column }:{ row: Row, column: any }) {
			if (_.has(this.cellNamesCmp, 'ZAKAZKA_CELL_COLOUR') && column.label === this.LocalizePopisPoli('ZAKAZKA_CELL_COLOUR')) {
				const rgb = intToRgb(row.cells[this.cellNamesCmp.ROWCOLOR]);
				if (rgb) return { background: rgb, color: 'transparent' };
				row.cells[this.cellNamesCmp.ZAKAZKA_CELL_COLOUR] = '';
			}
			const data = getColumnsRowMapObject(this.table.columns, row.cells);
			if (data.IS_CUSTOMER_FIRST_VISIT && this.dmsSys.CustomerFirstPrp) {
				const highlightRow = intToRgb(row.cells[this.cellNamesCmp.FIRST_VISIT_COLOR_CODE]);
				return highlightRow ? { background: highlightRow } : null;
			}
			return null;
		},
		createClickFun() {
			(this.$refs.createModal as any).createClickFun();
		},
		PojistovnaIdPrpChange() {
			if (!this.PojistovnaIdPrp) {
				this.PojistovnaId = null;
				this.PojistovnaIdText = null;
			}
		},
		updateSplitValue() {
			if (!this.IsSplittedOrder) {
				this.IsSplittedOrder = null;
			}
		},
		PojistCisPuPrpChange() {
			if (!this.PojistCisPuPrp) {
				this.PojistCisPu = null;
			}
		},
		PojistCisPuChange() {
			this.PojistCisPuPrp = !this.PojistCisPu ? null : true;
		},
		PojistCisExtzaklikvPrpChange() {
			if (!this.PojistCisExtzaklikvPrp) {
				this.PojistCisExtzaklikv = null;
			}
		},
		PojistCisExtzaklikvChange() {
			this.PojistCisExtzaklikvPrp = !this.PojistCisExtzaklikv ? null : true;
		},
		LeasCisSchvalPrpChange() {
			if (!this.LeasCisSchvalPrp) {
				this.LeasCisSchval = null;
			}
		},
		LeasCisSchvalChange() {
			this.LeasCisSchvalPrp = !this.LeasCisSchval ? null : true;
		},
		editZakazka(event: any) {
			this.openZakazka(event, PageMode.EDIT);
		},
		viewZakazka(event: any) {
			this.openZakazka(event, PageMode.VIEW);
		},
		async openZakazka(event: any, mode: PageMode) {
			await openEdit(NAME, mode, { id: event.data.ZAKAZKA_ID, zakazkaDruh: event.data.ZAKAZKA_DRUH });
		},
		async getOrderDetails(ZakazkaId: number) {
			this.startLoading();
			const { data: serviceAdviserDetailsResp } = await apiProvider.getSADetails(ZakazkaId);
			this.serviceAdviserDetails = objectToCamelCaseShallow(serviceAdviserDetailsResp);
			this.serviceAdviserDetails.rODate = formatDate(this.serviceAdviserDetails.rODate)!;
			this.serviceAdviserDetails.isIframeJobListVisible = false;
			this.visibleJobCardModal = true;
			this.endLoading();
		},
		onUpdateVisibleJobCardModal() {
			this.visibleJobCardModal = false;
		},
	},
	mounted() {
		if (this.$route.params.checkFilters) {
			this.vuexMutationWatcherUnsubscribe = this.$store.subscribe((mutation) => {
				if (mutation.type === `${this.storeUri}/${UPDATE_BASIC_FILTER}`) {
					this.setZakazkaCheckboxFilters(true);
				}
			});
		}
	},
	beforeDestroy() {
		this.vuexMutationWatcherUnsubscribe && this.vuexMutationWatcherUnsubscribe();
	},
});
